export enum Territories {
  EMPTY = "",
  HONG_KONG = "Hong Kong",
  KOWLOON = "Kowloon",
  NEW_TERRITORIES = "New Territories",
}
